export const SET_DATA_SHIPPING = "SET_DATA_SHIPPING";
export const SET_DATA_OPTIONS_CATEGORY = "SET_DATA_OPTIONS_CATEGORY";
export const SET_DATA_SETTING = "SET_DATA_SETTING";
export const SET_DATA_LANGUAGE = "SET_DATA_LANGUAGE";
export const SET_DATA_CURRENCY = "SET_DATA_CURRENCY";
export const SET_DATA_COLOR = "SET_DATA_COLOR";
export const SET_DATA_TAG = "SET_DATA_TAG";
export const SET_DATA_SIZE = "SET_DATA_SIZE";
export const SET_USER_LOGIN = "SET_USER_LOGIN";
export const SET_LIMIT_REVIEWS = "SET_LIMIT_REVIEWS";
export const SET_PAGE_REVIEWS = "SET_PAGE_REVIEWS";
export const RESET_PAGE_REVIEWS = "RESET_PAGE_REVIEWS";

export const SET_LIMIT_PRODUCTS = "SET_LIMIT_PRODUCTS";
export const SET_PAGE_PRODUCTS = "SET_PAGE_PRODUCTS";
export const SET_CATEGORY_FILTER = "SET_CATEGORY_FILTER";
export const SET_BRAND_FILTER = "SET_BRAND_FILTER";
export const RESET_BRAND_FILTER = "RESET_BRAND_FILTER";
export const SET_DATA_SORTING = "SET_DATA_SORTING";
export const SET_PRICE_SORTING = "SET_PRICE_SORTING";
export const SET_COLOR_FILTER = "SET_COLOR_FILTER";
export const SET_TAG_FILTER = "SET_TAG_FILTER";
export const SET_SIZE_FILTER = "SET_SIZE_FILTER";
export const SET_SEARCH_ITEM = "SET_SEARCH_ITEM";
export const SET_WISHLIST_ITEM = "SET_WISHLIST_ITEM";
export const SET_MENU_ORDER = "SET_MENU_ORDER";
export const LOG_OUT_ACCOUNT = "LOG_OUT_ACCOUNT";
export const FILTERED_DATA_PRODUCT_HOME = "FILTERED_DATA_PRODUCT_HOME";
